import React, { useState, useEffect, useRef } from "react";
import InputField from "./InputField";
import DropDownMenu from "./DropDownMenu";
import { useDispatch, useSelector } from "react-redux";
import { columnDataTypesOptions } from "../utils";
import {
  saveAsOutputColumn,
  getOutputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import Button from "./Button";
import toast from "react-hot-toast";

const initialOutputColumnData = {
  outColChr: "", // character of Column
  outColDT: "", // out column data type
  userDefinedData: "", // if any custom data to be inserted
  outputColumnHeader: "", // define header for output column
  cloneColumn: "", // store same output for cloned ones
  fixDecimalPlaces: "", // whether to fix decimal places
};

const OutputColumnForms = () => {
  const dispatch = useDispatch();
  const state = useSelector(getEditStateData);
  const outputColsData = useSelector(getOutputColumnsData);
  const [outputColumnData, setoutputColumnData] = useState(
    initialOutputColumnData,
  );
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const firstInputRef = useRef(null);
  const USfalg = useSelector(getChangesFlag);

  const focusFirstField = () => {
    setTimeout(() => {
      firstInputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    focusFirstField();
  }, []);

  useEffect(() => {
    if (state?.type === "outputColumnForm") {
      setoutputColumnData(state.data);
      setIsInLocalEditMode(true);
    }
  }, [state]);

  const handleOnChange = (e) => {
    setoutputColumnData((prevData) => ({
      ...prevData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    }));
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const isSaveDisabled =
    !outputColumnData.outColChr ||
    !outputColumnData.outColDT ||
    !outputColumnData.outputColumnHeader;

  const handleInsertColumn = () => {
    const alreadyExist = outputColsData.find(
      (col) => col.outColChr === outputColumnData.outColChr,
    );
    toast.dismiss();
    if (alreadyExist && !isInLocalEditMode) {
      toast.error(`Column '${outputColumnData.outColChr}' already exists!`);
      return;
    }

    dispatch(saveAsOutputColumn(outputColumnData));
    toast.success(
      `Column '${outputColumnData.outColChr}' ${
        isInLocalEditMode ? "updated" : "added"
      } successfully`,
    );
    reset();
  };

  const reset = () => {
    setoutputColumnData(initialOutputColumnData);
    setIsInLocalEditMode(false);
    focusFirstField();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !isSaveDisabled) {
      e.preventDefault();
      handleInsertColumn();
    }
  };

  return (
    <div className="w-full my-10 rounded mx-1">
      <h1 className="font-bold text-center m-2">Configure Output Columns</h1>
      <div className="w-full my-8  p-2 lg:p-4 rounded mx-1">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <InputField
            inputRef={firstInputRef}
            label={"Define Column (only character)"}
            name={"outColChr"}
            type="text"
            placeholder={"Enter column name"}
            value={outputColumnData.outColChr}
            required={true}
            disabled={isInLocalEditMode}
            onChange={(e) => {
              const value = e.target.value
                .replace(/[^a-zA-Z]/g, "")
                .toUpperCase()
                .trim();
              e.target.value = value;
              handleOnChange(e);
            }}
            onKeyDown={handleKeyDown}
          />
          <DropDownMenu
            label="Select Column Data type"
            name="outColDT"
            disabled={isInLocalEditMode}
            value={outputColumnData.outColDT}
            options={columnDataTypesOptions}
            onChange={(e) => handleOnChange(e)}
            required
            onKeyDown={handleKeyDown}
          />
          <InputField
            label={"Define Header"}
            name={"outputColumnHeader"}
            type="text"
            placeholder={"InvoiceNumber"}
            value={outputColumnData.outputColumnHeader}
            onChange={(e) => handleOnChange(e)}
            onKeyDown={handleKeyDown}
            required={true}
          />
          <InputField
            label={"Define custom data for this column"}
            name={"userDefinedData"}
            type="text"
            placeholder={"Enter custom data"}
            value={outputColumnData.userDefinedData}
            onChange={(e) => handleOnChange(e)}
            onKeyDown={handleKeyDown}
          />
          <DropDownMenu
            label="Clone Output Column"
            name="cloneColumn"
            value={outputColumnData.cloneColumn}
            options={outputColsData.map((item) => ({
              label: item.outColChr,
              value: item.outColChr,
            }))}
            onChange={(e) => handleOnChange(e, "selectedInputColum")}
            onKeyDown={handleKeyDown}
          />
          {outputColumnData.outColDT === "2" && (
            <DropDownMenu
              label="Fix Decimal Places"
              name="fixDecimalPlaces"
              value={outputColumnData.fixDecimalPlaces ?? ""}
              options={[
                { label: "None", value: "" },
                { label: "0", value: 0 },
                { label: "1", value: 1 },
                { label: "2", value: 2 },
                { label: "3", value: 3 },
                { label: "4", value: 4 },
                { label: "5", value: 5 },
              ]}
              onChange={(e) => handleOnChange(e)}
              onKeyDown={handleKeyDown}
            />
          )}
        </div>
        <div className="flex gap-2">
          <div className="mt-4">
            <Button
              disabled={isSaveDisabled}
              btnType="save"
              btnText={`${isInLocalEditMode ? "Update Column" : "Save Column"}`}
              handleOnClick={handleInsertColumn}
            />
          </div>

          <div className="mt-4">
            <Button
              btnType="cancel"
              btnText={"Clear Column"}
              handleOnClick={reset}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutputColumnForms;
